/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Okami API
 * The Okami rest api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddRowInCalendarDto,
  AddWorkInCustomListDto,
  AdminControllerFetchUsersParams,
  CalendarModel,
  CompareSubscriberAuthTokenDto,
  CreateCalendarDto,
  CreateCustomListDto,
  CreateCustomListResponseModel,
  CreateSharedWorkDto,
  CreateSharedWorkResponseModel,
  CreateSubscriberDto,
  CreateTagDto,
  CustomListModel,
  CustomListWithWorksModel,
  FetchUsersModel,
  NotificationHttp,
  PaymentStatusModel,
  RegisterMobilePushSubscriberDto,
  RegisterWebPushSubscriptionDto,
  ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams,
  ScrappingReportDto,
  ScrappingReportModel,
  SendAuthCodeByEmailValidator,
  TagControllerListTagsParams,
  TagModel,
  TagModelPaged,
  ToggleShareCollectionDto,
  UpdateCustomListDto,
  UpdateTagDto,
  UpdateTelegramChatIdValidator,
  UpdateUserRoleDto,
  ValidateEmailDto
} from './models';

import { customInstance } from '../../lib/axios/index';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const authControllerSendConfirmEmail = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/auth/user/send-confirm-email`, method: 'POST', signal
    },
      options);
    }
  


export const getAuthControllerSendConfirmEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSendConfirmEmail>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerSendConfirmEmail>>, TError,void, TContext> => {

const mutationKey = ['authControllerSendConfirmEmail'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerSendConfirmEmail>>, void> = () => {
          

          return  authControllerSendConfirmEmail(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerSendConfirmEmailMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerSendConfirmEmail>>>
    
    export type AuthControllerSendConfirmEmailMutationError = unknown

    export const useAuthControllerSendConfirmEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerSendConfirmEmail>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerSendConfirmEmail>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAuthControllerSendConfirmEmailMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const authControllerValidateEmailCode = (
    validateEmailDto: ValidateEmailDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/auth/user/validate-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: validateEmailDto, signal
    },
      options);
    }
  


export const getAuthControllerValidateEmailCodeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerValidateEmailCode>>, TError,{data: ValidateEmailDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerValidateEmailCode>>, TError,{data: ValidateEmailDto}, TContext> => {

const mutationKey = ['authControllerValidateEmailCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerValidateEmailCode>>, {data: ValidateEmailDto}> = (props) => {
          const {data} = props ?? {};

          return  authControllerValidateEmailCode(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerValidateEmailCodeMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerValidateEmailCode>>>
    export type AuthControllerValidateEmailCodeMutationBody = ValidateEmailDto
    export type AuthControllerValidateEmailCodeMutationError = unknown

    export const useAuthControllerValidateEmailCode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerValidateEmailCode>>, TError,{data: ValidateEmailDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authControllerValidateEmailCode>>,
        TError,
        {data: ValidateEmailDto},
        TContext
      > => {

      const mutationOptions = getAuthControllerValidateEmailCodeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const notificationControllerSubscribeInMobile = (
    registerMobilePushSubscriberDto: RegisterMobilePushSubscriberDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/notification/push/mobile/subscribe`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerMobilePushSubscriberDto, signal
    },
      options);
    }
  


export const getNotificationControllerSubscribeInMobileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerSubscribeInMobile>>, TError,{data: RegisterMobilePushSubscriberDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationControllerSubscribeInMobile>>, TError,{data: RegisterMobilePushSubscriberDto}, TContext> => {

const mutationKey = ['notificationControllerSubscribeInMobile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationControllerSubscribeInMobile>>, {data: RegisterMobilePushSubscriberDto}> = (props) => {
          const {data} = props ?? {};

          return  notificationControllerSubscribeInMobile(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationControllerSubscribeInMobileMutationResult = NonNullable<Awaited<ReturnType<typeof notificationControllerSubscribeInMobile>>>
    export type NotificationControllerSubscribeInMobileMutationBody = RegisterMobilePushSubscriberDto
    export type NotificationControllerSubscribeInMobileMutationError = unknown

    export const useNotificationControllerSubscribeInMobile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerSubscribeInMobile>>, TError,{data: RegisterMobilePushSubscriberDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationControllerSubscribeInMobile>>,
        TError,
        {data: RegisterMobilePushSubscriberDto},
        TContext
      > => {

      const mutationOptions = getNotificationControllerSubscribeInMobileMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const notificationControllerGetRecentNotifications = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationHttp[]>(
      {url: `/notification/recent`, method: 'GET', signal
    },
      options);
    }
  

export const getNotificationControllerGetRecentNotificationsQueryKey = () => {
    return [`/notification/recent`] as const;
    }

    
export const getNotificationControllerGetRecentNotificationsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationControllerGetRecentNotificationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>> = ({ signal }) => notificationControllerGetRecentNotifications(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationControllerGetRecentNotificationsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>
export type NotificationControllerGetRecentNotificationsInfiniteQueryError = unknown


export function useNotificationControllerGetRecentNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>,
          TError,
          Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetRecentNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>,
          TError,
          Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetRecentNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationControllerGetRecentNotificationsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationControllerGetRecentNotificationsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions , queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationControllerGetRecentNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationControllerGetRecentNotificationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>> = ({ signal }) => notificationControllerGetRecentNotifications(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationControllerGetRecentNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>
export type NotificationControllerGetRecentNotificationsQueryError = unknown


export function useNotificationControllerGetRecentNotifications<TData = Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>,
          TError,
          Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetRecentNotifications<TData = Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>,
          TError,
          Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetRecentNotifications<TData = Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationControllerGetRecentNotifications<TData = Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationControllerGetRecentNotificationsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationControllerGetRecentNotificationsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationControllerGetRecentNotificationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>> = ({ signal }) => notificationControllerGetRecentNotifications(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationControllerGetRecentNotificationsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>
export type NotificationControllerGetRecentNotificationsSuspenseQueryError = unknown


export function useNotificationControllerGetRecentNotificationsSuspense<TData = Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetRecentNotificationsSuspense<TData = Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetRecentNotificationsSuspense<TData = Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationControllerGetRecentNotificationsSuspense<TData = Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationControllerGetRecentNotificationsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationControllerGetRecentNotificationsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>, TError = unknown>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationControllerGetRecentNotificationsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>> = ({ signal }) => notificationControllerGetRecentNotifications(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationControllerGetRecentNotificationsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>
export type NotificationControllerGetRecentNotificationsSuspenseInfiniteQueryError = unknown


export function useNotificationControllerGetRecentNotificationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>, TError = unknown>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetRecentNotificationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetRecentNotificationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationControllerGetRecentNotificationsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetRecentNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationControllerGetRecentNotificationsSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions , queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const notificationControllerMarkNotificationAsRead = (
    notificationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/notification/mark-read/${notificationId}`, method: 'POST', signal
    },
      options);
    }
  


export const getNotificationControllerMarkNotificationAsReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerMarkNotificationAsRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationControllerMarkNotificationAsRead>>, TError,{notificationId: string}, TContext> => {

const mutationKey = ['notificationControllerMarkNotificationAsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationControllerMarkNotificationAsRead>>, {notificationId: string}> = (props) => {
          const {notificationId} = props ?? {};

          return  notificationControllerMarkNotificationAsRead(notificationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationControllerMarkNotificationAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof notificationControllerMarkNotificationAsRead>>>
    
    export type NotificationControllerMarkNotificationAsReadMutationError = unknown

    export const useNotificationControllerMarkNotificationAsRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerMarkNotificationAsRead>>, TError,{notificationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationControllerMarkNotificationAsRead>>,
        TError,
        {notificationId: string},
        TContext
      > => {

      const mutationOptions = getNotificationControllerMarkNotificationAsReadMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const notificationControllerUpdateChatId = (
    updateTelegramChatIdValidator: UpdateTelegramChatIdValidator,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/notification/telegram/update-chat-id`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateTelegramChatIdValidator
    },
      options);
    }
  


export const getNotificationControllerUpdateChatIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerUpdateChatId>>, TError,{data: UpdateTelegramChatIdValidator}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationControllerUpdateChatId>>, TError,{data: UpdateTelegramChatIdValidator}, TContext> => {

const mutationKey = ['notificationControllerUpdateChatId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationControllerUpdateChatId>>, {data: UpdateTelegramChatIdValidator}> = (props) => {
          const {data} = props ?? {};

          return  notificationControllerUpdateChatId(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationControllerUpdateChatIdMutationResult = NonNullable<Awaited<ReturnType<typeof notificationControllerUpdateChatId>>>
    export type NotificationControllerUpdateChatIdMutationBody = UpdateTelegramChatIdValidator
    export type NotificationControllerUpdateChatIdMutationError = unknown

    export const useNotificationControllerUpdateChatId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerUpdateChatId>>, TError,{data: UpdateTelegramChatIdValidator}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationControllerUpdateChatId>>,
        TError,
        {data: UpdateTelegramChatIdValidator},
        TContext
      > => {

      const mutationOptions = getNotificationControllerUpdateChatIdMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const notificationControllerSendAuthCode = (
    sendAuthCodeByEmailValidator: SendAuthCodeByEmailValidator,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/notification/telegram/send-auth-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: sendAuthCodeByEmailValidator, signal
    },
      options);
    }
  


export const getNotificationControllerSendAuthCodeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerSendAuthCode>>, TError,{data: SendAuthCodeByEmailValidator}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationControllerSendAuthCode>>, TError,{data: SendAuthCodeByEmailValidator}, TContext> => {

const mutationKey = ['notificationControllerSendAuthCode'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationControllerSendAuthCode>>, {data: SendAuthCodeByEmailValidator}> = (props) => {
          const {data} = props ?? {};

          return  notificationControllerSendAuthCode(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationControllerSendAuthCodeMutationResult = NonNullable<Awaited<ReturnType<typeof notificationControllerSendAuthCode>>>
    export type NotificationControllerSendAuthCodeMutationBody = SendAuthCodeByEmailValidator
    export type NotificationControllerSendAuthCodeMutationError = unknown

    export const useNotificationControllerSendAuthCode = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerSendAuthCode>>, TError,{data: SendAuthCodeByEmailValidator}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationControllerSendAuthCode>>,
        TError,
        {data: SendAuthCodeByEmailValidator},
        TContext
      > => {

      const mutationOptions = getNotificationControllerSendAuthCodeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const notificationControllerCompareSubscriberAuthCodeCall = (
    compareSubscriberAuthTokenDto: CompareSubscriberAuthTokenDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/notification/telegram/compare-auth-code`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: compareSubscriberAuthTokenDto, signal
    },
      options);
    }
  


export const getNotificationControllerCompareSubscriberAuthCodeCallMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerCompareSubscriberAuthCodeCall>>, TError,{data: CompareSubscriberAuthTokenDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationControllerCompareSubscriberAuthCodeCall>>, TError,{data: CompareSubscriberAuthTokenDto}, TContext> => {

const mutationKey = ['notificationControllerCompareSubscriberAuthCodeCall'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationControllerCompareSubscriberAuthCodeCall>>, {data: CompareSubscriberAuthTokenDto}> = (props) => {
          const {data} = props ?? {};

          return  notificationControllerCompareSubscriberAuthCodeCall(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationControllerCompareSubscriberAuthCodeCallMutationResult = NonNullable<Awaited<ReturnType<typeof notificationControllerCompareSubscriberAuthCodeCall>>>
    export type NotificationControllerCompareSubscriberAuthCodeCallMutationBody = CompareSubscriberAuthTokenDto
    export type NotificationControllerCompareSubscriberAuthCodeCallMutationError = unknown

    export const useNotificationControllerCompareSubscriberAuthCodeCall = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerCompareSubscriberAuthCodeCall>>, TError,{data: CompareSubscriberAuthTokenDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationControllerCompareSubscriberAuthCodeCall>>,
        TError,
        {data: CompareSubscriberAuthTokenDto},
        TContext
      > => {

      const mutationOptions = getNotificationControllerCompareSubscriberAuthCodeCallMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const notificationControllerGetSubscriberByEmail = (
    email: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/notification/telegram/find/${email}`, method: 'GET', signal
    },
      options);
    }
  

export const getNotificationControllerGetSubscriberByEmailQueryKey = (email: string,) => {
    return [`/notification/telegram/find/${email}`] as const;
    }

    
export const getNotificationControllerGetSubscriberByEmailInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>, TError = unknown>(email: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationControllerGetSubscriberByEmailQueryKey(email);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>> = ({ signal }) => notificationControllerGetSubscriberByEmail(email, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(email), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationControllerGetSubscriberByEmailInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>
export type NotificationControllerGetSubscriberByEmailInfiniteQueryError = unknown


export function useNotificationControllerGetSubscriberByEmailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>, TError = unknown>(
 email: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>,
          TError,
          Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetSubscriberByEmailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>,
          TError,
          Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetSubscriberByEmailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationControllerGetSubscriberByEmailInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationControllerGetSubscriberByEmailInfiniteQueryOptions(email,options)

  const query = useInfiniteQuery(queryOptions , queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationControllerGetSubscriberByEmailQueryOptions = <TData = Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError = unknown>(email: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationControllerGetSubscriberByEmailQueryKey(email);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>> = ({ signal }) => notificationControllerGetSubscriberByEmail(email, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(email), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationControllerGetSubscriberByEmailQueryResult = NonNullable<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>
export type NotificationControllerGetSubscriberByEmailQueryError = unknown


export function useNotificationControllerGetSubscriberByEmail<TData = Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError = unknown>(
 email: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>,
          TError,
          Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetSubscriberByEmail<TData = Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>,
          TError,
          Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetSubscriberByEmail<TData = Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationControllerGetSubscriberByEmail<TData = Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationControllerGetSubscriberByEmailQueryOptions(email,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationControllerGetSubscriberByEmailSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError = unknown>(email: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationControllerGetSubscriberByEmailQueryKey(email);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>> = ({ signal }) => notificationControllerGetSubscriberByEmail(email, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationControllerGetSubscriberByEmailSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>
export type NotificationControllerGetSubscriberByEmailSuspenseQueryError = unknown


export function useNotificationControllerGetSubscriberByEmailSuspense<TData = Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError = unknown>(
 email: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetSubscriberByEmailSuspense<TData = Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetSubscriberByEmailSuspense<TData = Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationControllerGetSubscriberByEmailSuspense<TData = Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationControllerGetSubscriberByEmailSuspenseQueryOptions(email,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNotificationControllerGetSubscriberByEmailSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>, TError = unknown>(email: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationControllerGetSubscriberByEmailQueryKey(email);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>> = ({ signal }) => notificationControllerGetSubscriberByEmail(email, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NotificationControllerGetSubscriberByEmailSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>
export type NotificationControllerGetSubscriberByEmailSuspenseInfiniteQueryError = unknown


export function useNotificationControllerGetSubscriberByEmailSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>, TError = unknown>(
 email: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetSubscriberByEmailSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNotificationControllerGetSubscriberByEmailSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useNotificationControllerGetSubscriberByEmailSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>>, TError = unknown>(
 email: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof notificationControllerGetSubscriberByEmail>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationControllerGetSubscriberByEmailSuspenseInfiniteQueryOptions(email,options)

  const query = useSuspenseInfiniteQuery(queryOptions , queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const notificationControllerSubscribeInWeb = (
    registerWebPushSubscriptionDto: RegisterWebPushSubscriptionDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/notification/push/web/subscribe`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerWebPushSubscriptionDto, signal
    },
      options);
    }
  


export const getNotificationControllerSubscribeInWebMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerSubscribeInWeb>>, TError,{data: RegisterWebPushSubscriptionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof notificationControllerSubscribeInWeb>>, TError,{data: RegisterWebPushSubscriptionDto}, TContext> => {

const mutationKey = ['notificationControllerSubscribeInWeb'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof notificationControllerSubscribeInWeb>>, {data: RegisterWebPushSubscriptionDto}> = (props) => {
          const {data} = props ?? {};

          return  notificationControllerSubscribeInWeb(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NotificationControllerSubscribeInWebMutationResult = NonNullable<Awaited<ReturnType<typeof notificationControllerSubscribeInWeb>>>
    export type NotificationControllerSubscribeInWebMutationBody = RegisterWebPushSubscriptionDto
    export type NotificationControllerSubscribeInWebMutationError = unknown

    export const useNotificationControllerSubscribeInWeb = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof notificationControllerSubscribeInWeb>>, TError,{data: RegisterWebPushSubscriptionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof notificationControllerSubscribeInWeb>>,
        TError,
        {data: RegisterWebPushSubscriptionDto},
        TContext
      > => {

      const mutationOptions = getNotificationControllerSubscribeInWebMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const paymentControllerCreateIntentPayment = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/payment/checkout`, method: 'POST', signal
    },
      options);
    }
  


export const getPaymentControllerCreateIntentPaymentMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentPayment>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentPayment>>, TError,void, TContext> => {

const mutationKey = ['paymentControllerCreateIntentPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentControllerCreateIntentPayment>>, void> = () => {
          

          return  paymentControllerCreateIntentPayment(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PaymentControllerCreateIntentPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof paymentControllerCreateIntentPayment>>>
    
    export type PaymentControllerCreateIntentPaymentMutationError = unknown

    export const usePaymentControllerCreateIntentPayment = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerCreateIntentPayment>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentControllerCreateIntentPayment>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPaymentControllerCreateIntentPaymentMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const paymentControllerWebhook = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/payment/webhook`, method: 'POST', signal
    },
      options);
    }
  


export const getPaymentControllerWebhookMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof paymentControllerWebhook>>, TError,void, TContext> => {

const mutationKey = ['paymentControllerWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof paymentControllerWebhook>>, void> = () => {
          

          return  paymentControllerWebhook(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PaymentControllerWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof paymentControllerWebhook>>>
    
    export type PaymentControllerWebhookMutationError = unknown

    export const usePaymentControllerWebhook = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof paymentControllerWebhook>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof paymentControllerWebhook>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPaymentControllerWebhookMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const paymentControllerChecksPaymentSubscriptionStatus = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentStatusModel>(
      {url: `/payment/subscription/status`, method: 'GET', signal
    },
      options);
    }
  

export const getPaymentControllerChecksPaymentSubscriptionStatusQueryKey = () => {
    return [`/payment/subscription/status`] as const;
    }

    
export const getPaymentControllerChecksPaymentSubscriptionStatusInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPaymentControllerChecksPaymentSubscriptionStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>> = ({ signal }) => paymentControllerChecksPaymentSubscriptionStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentControllerChecksPaymentSubscriptionStatusInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>
export type PaymentControllerChecksPaymentSubscriptionStatusInfiniteQueryError = unknown


export function usePaymentControllerChecksPaymentSubscriptionStatusInfinite<TData = InfiniteData<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>,
          TError,
          Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentControllerChecksPaymentSubscriptionStatusInfinite<TData = InfiniteData<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>,
          TError,
          Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentControllerChecksPaymentSubscriptionStatusInfinite<TData = InfiniteData<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentControllerChecksPaymentSubscriptionStatusInfinite<TData = InfiniteData<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPaymentControllerChecksPaymentSubscriptionStatusInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions , queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPaymentControllerChecksPaymentSubscriptionStatusQueryOptions = <TData = Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPaymentControllerChecksPaymentSubscriptionStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>> = ({ signal }) => paymentControllerChecksPaymentSubscriptionStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentControllerChecksPaymentSubscriptionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>
export type PaymentControllerChecksPaymentSubscriptionStatusQueryError = unknown


export function usePaymentControllerChecksPaymentSubscriptionStatus<TData = Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>,
          TError,
          Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentControllerChecksPaymentSubscriptionStatus<TData = Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>,
          TError,
          Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentControllerChecksPaymentSubscriptionStatus<TData = Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentControllerChecksPaymentSubscriptionStatus<TData = Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPaymentControllerChecksPaymentSubscriptionStatusQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPaymentControllerChecksPaymentSubscriptionStatusSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPaymentControllerChecksPaymentSubscriptionStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>> = ({ signal }) => paymentControllerChecksPaymentSubscriptionStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentControllerChecksPaymentSubscriptionStatusSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>
export type PaymentControllerChecksPaymentSubscriptionStatusSuspenseQueryError = unknown


export function usePaymentControllerChecksPaymentSubscriptionStatusSuspense<TData = Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentControllerChecksPaymentSubscriptionStatusSuspense<TData = Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentControllerChecksPaymentSubscriptionStatusSuspense<TData = Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentControllerChecksPaymentSubscriptionStatusSuspense<TData = Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPaymentControllerChecksPaymentSubscriptionStatusSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getPaymentControllerChecksPaymentSubscriptionStatusSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>, TError = unknown>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPaymentControllerChecksPaymentSubscriptionStatusQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>> = ({ signal }) => paymentControllerChecksPaymentSubscriptionStatus(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PaymentControllerChecksPaymentSubscriptionStatusSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>
export type PaymentControllerChecksPaymentSubscriptionStatusSuspenseInfiniteQueryError = unknown


export function usePaymentControllerChecksPaymentSubscriptionStatusSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>, TError = unknown>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentControllerChecksPaymentSubscriptionStatusSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePaymentControllerChecksPaymentSubscriptionStatusSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePaymentControllerChecksPaymentSubscriptionStatusSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof paymentControllerChecksPaymentSubscriptionStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPaymentControllerChecksPaymentSubscriptionStatusSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions , queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const tagControllerCreate = (
    createTagDto: CreateTagDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/tags`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createTagDto, signal
    },
      options);
    }
  


export const getTagControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagControllerCreate>>, TError,{data: CreateTagDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tagControllerCreate>>, TError,{data: CreateTagDto}, TContext> => {

const mutationKey = ['tagControllerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagControllerCreate>>, {data: CreateTagDto}> = (props) => {
          const {data} = props ?? {};

          return  tagControllerCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TagControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof tagControllerCreate>>>
    export type TagControllerCreateMutationBody = CreateTagDto
    export type TagControllerCreateMutationError = unknown

    export const useTagControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagControllerCreate>>, TError,{data: CreateTagDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tagControllerCreate>>,
        TError,
        {data: CreateTagDto},
        TContext
      > => {

      const mutationOptions = getTagControllerCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const tagControllerListTags = (
    params: TagControllerListTagsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TagModelPaged>(
      {url: `/tags`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getTagControllerListTagsQueryKey = (params: TagControllerListTagsParams,) => {
    return [`/tags`, ...(params ? [params]: [])] as const;
    }

    
export const getTagControllerListTagsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof tagControllerListTags>>, TagControllerListTagsParams['page']>, TError = unknown>(params: TagControllerListTagsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTagControllerListTagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']> = ({ signal, pageParam }) => tagControllerListTags({...params, 'page': pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TagControllerListTagsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof tagControllerListTags>>>
export type TagControllerListTagsInfiniteQueryError = unknown


export function useTagControllerListTagsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerListTags>>, TagControllerListTagsParams['page']>, TError = unknown>(
 params: TagControllerListTagsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagControllerListTags>>,
          TError,
          Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerListTagsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerListTags>>, TagControllerListTagsParams['page']>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagControllerListTags>>,
          TError,
          Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerListTagsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerListTags>>, TagControllerListTagsParams['page']>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTagControllerListTagsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerListTags>>, TagControllerListTagsParams['page']>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTagControllerListTagsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions , queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTagControllerListTagsQueryOptions = <TData = Awaited<ReturnType<typeof tagControllerListTags>>, TError = unknown>(params: TagControllerListTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTagControllerListTagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tagControllerListTags>>> = ({ signal }) => tagControllerListTags(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TagControllerListTagsQueryResult = NonNullable<Awaited<ReturnType<typeof tagControllerListTags>>>
export type TagControllerListTagsQueryError = unknown


export function useTagControllerListTags<TData = Awaited<ReturnType<typeof tagControllerListTags>>, TError = unknown>(
 params: TagControllerListTagsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagControllerListTags>>,
          TError,
          Awaited<ReturnType<typeof tagControllerListTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerListTags<TData = Awaited<ReturnType<typeof tagControllerListTags>>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagControllerListTags>>,
          TError,
          Awaited<ReturnType<typeof tagControllerListTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerListTags<TData = Awaited<ReturnType<typeof tagControllerListTags>>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTagControllerListTags<TData = Awaited<ReturnType<typeof tagControllerListTags>>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTagControllerListTagsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTagControllerListTagsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof tagControllerListTags>>, TError = unknown>(params: TagControllerListTagsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTagControllerListTagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tagControllerListTags>>> = ({ signal }) => tagControllerListTags(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TagControllerListTagsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof tagControllerListTags>>>
export type TagControllerListTagsSuspenseQueryError = unknown


export function useTagControllerListTagsSuspense<TData = Awaited<ReturnType<typeof tagControllerListTags>>, TError = unknown>(
 params: TagControllerListTagsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerListTagsSuspense<TData = Awaited<ReturnType<typeof tagControllerListTags>>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerListTagsSuspense<TData = Awaited<ReturnType<typeof tagControllerListTags>>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTagControllerListTagsSuspense<TData = Awaited<ReturnType<typeof tagControllerListTags>>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTagControllerListTagsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTagControllerListTagsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof tagControllerListTags>>, TagControllerListTagsParams['page']>, TError = unknown>(params: TagControllerListTagsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTagControllerListTagsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']> = ({ signal, pageParam }) => tagControllerListTags({...params, 'page': pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TagControllerListTagsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof tagControllerListTags>>>
export type TagControllerListTagsSuspenseInfiniteQueryError = unknown


export function useTagControllerListTagsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerListTags>>, TagControllerListTagsParams['page']>, TError = unknown>(
 params: TagControllerListTagsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerListTagsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerListTags>>, TagControllerListTagsParams['page']>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerListTagsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerListTags>>, TagControllerListTagsParams['page']>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTagControllerListTagsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerListTags>>, TagControllerListTagsParams['page']>, TError = unknown>(
 params: TagControllerListTagsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerListTags>>, TError, TData, Awaited<ReturnType<typeof tagControllerListTags>>, QueryKey, TagControllerListTagsParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTagControllerListTagsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions , queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const tagControllerUpdateTag = (
    id: string,
    updateTagDto: UpdateTagDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/tags/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateTagDto
    },
      options);
    }
  


export const getTagControllerUpdateTagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagControllerUpdateTag>>, TError,{id: string;data: UpdateTagDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tagControllerUpdateTag>>, TError,{id: string;data: UpdateTagDto}, TContext> => {

const mutationKey = ['tagControllerUpdateTag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagControllerUpdateTag>>, {id: string;data: UpdateTagDto}> = (props) => {
          const {id,data} = props ?? {};

          return  tagControllerUpdateTag(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TagControllerUpdateTagMutationResult = NonNullable<Awaited<ReturnType<typeof tagControllerUpdateTag>>>
    export type TagControllerUpdateTagMutationBody = UpdateTagDto
    export type TagControllerUpdateTagMutationError = unknown

    export const useTagControllerUpdateTag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagControllerUpdateTag>>, TError,{id: string;data: UpdateTagDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tagControllerUpdateTag>>,
        TError,
        {id: string;data: UpdateTagDto},
        TContext
      > => {

      const mutationOptions = getTagControllerUpdateTagMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const tagControllerDeleteTag = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/tags/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getTagControllerDeleteTagMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagControllerDeleteTag>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof tagControllerDeleteTag>>, TError,{id: string}, TContext> => {

const mutationKey = ['tagControllerDeleteTag'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tagControllerDeleteTag>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  tagControllerDeleteTag(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type TagControllerDeleteTagMutationResult = NonNullable<Awaited<ReturnType<typeof tagControllerDeleteTag>>>
    
    export type TagControllerDeleteTagMutationError = unknown

    export const useTagControllerDeleteTag = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tagControllerDeleteTag>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tagControllerDeleteTag>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getTagControllerDeleteTagMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const tagControllerFetchAllTags = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TagModel[]>(
      {url: `/tags/all`, method: 'GET', signal
    },
      options);
    }
  

export const getTagControllerFetchAllTagsQueryKey = () => {
    return [`/tags/all`] as const;
    }

    
export const getTagControllerFetchAllTagsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTagControllerFetchAllTagsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tagControllerFetchAllTags>>> = ({ signal }) => tagControllerFetchAllTags(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TagControllerFetchAllTagsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>
export type TagControllerFetchAllTagsInfiniteQueryError = unknown


export function useTagControllerFetchAllTagsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagControllerFetchAllTags>>,
          TError,
          Awaited<ReturnType<typeof tagControllerFetchAllTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerFetchAllTagsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagControllerFetchAllTags>>,
          TError,
          Awaited<ReturnType<typeof tagControllerFetchAllTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerFetchAllTagsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTagControllerFetchAllTagsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTagControllerFetchAllTagsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions , queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTagControllerFetchAllTagsQueryOptions = <TData = Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTagControllerFetchAllTagsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tagControllerFetchAllTags>>> = ({ signal }) => tagControllerFetchAllTags(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TagControllerFetchAllTagsQueryResult = NonNullable<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>
export type TagControllerFetchAllTagsQueryError = unknown


export function useTagControllerFetchAllTags<TData = Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagControllerFetchAllTags>>,
          TError,
          Awaited<ReturnType<typeof tagControllerFetchAllTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerFetchAllTags<TData = Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tagControllerFetchAllTags>>,
          TError,
          Awaited<ReturnType<typeof tagControllerFetchAllTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerFetchAllTags<TData = Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTagControllerFetchAllTags<TData = Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTagControllerFetchAllTagsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTagControllerFetchAllTagsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTagControllerFetchAllTagsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tagControllerFetchAllTags>>> = ({ signal }) => tagControllerFetchAllTags(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TagControllerFetchAllTagsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>
export type TagControllerFetchAllTagsSuspenseQueryError = unknown


export function useTagControllerFetchAllTagsSuspense<TData = Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerFetchAllTagsSuspense<TData = Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerFetchAllTagsSuspense<TData = Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTagControllerFetchAllTagsSuspense<TData = Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTagControllerFetchAllTagsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTagControllerFetchAllTagsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>, TError = unknown>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTagControllerFetchAllTagsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tagControllerFetchAllTags>>> = ({ signal }) => tagControllerFetchAllTags(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TagControllerFetchAllTagsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>
export type TagControllerFetchAllTagsSuspenseInfiniteQueryError = unknown


export function useTagControllerFetchAllTagsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>, TError = unknown>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerFetchAllTagsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTagControllerFetchAllTagsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTagControllerFetchAllTagsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof tagControllerFetchAllTags>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof tagControllerFetchAllTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTagControllerFetchAllTagsSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions , queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const calendarControllerFetchUserCalendar = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CalendarModel>(
      {url: `/calendar`, method: 'GET', signal
    },
      options);
    }
  

export const getCalendarControllerFetchUserCalendarQueryKey = () => {
    return [`/calendar`] as const;
    }

    
export const getCalendarControllerFetchUserCalendarInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>, TError = CalendarModel>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalendarControllerFetchUserCalendarQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>> = ({ signal }) => calendarControllerFetchUserCalendar(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CalendarControllerFetchUserCalendarInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>
export type CalendarControllerFetchUserCalendarInfiniteQueryError = CalendarModel


export function useCalendarControllerFetchUserCalendarInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>, TError = CalendarModel>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>,
          TError,
          Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarControllerFetchUserCalendarInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>, TError = CalendarModel>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>,
          TError,
          Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarControllerFetchUserCalendarInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>, TError = CalendarModel>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCalendarControllerFetchUserCalendarInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>, TError = CalendarModel>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCalendarControllerFetchUserCalendarInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions , queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCalendarControllerFetchUserCalendarQueryOptions = <TData = Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError = CalendarModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalendarControllerFetchUserCalendarQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>> = ({ signal }) => calendarControllerFetchUserCalendar(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CalendarControllerFetchUserCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>
export type CalendarControllerFetchUserCalendarQueryError = CalendarModel


export function useCalendarControllerFetchUserCalendar<TData = Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError = CalendarModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>,
          TError,
          Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarControllerFetchUserCalendar<TData = Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError = CalendarModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>,
          TError,
          Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarControllerFetchUserCalendar<TData = Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError = CalendarModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCalendarControllerFetchUserCalendar<TData = Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError = CalendarModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCalendarControllerFetchUserCalendarQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCalendarControllerFetchUserCalendarSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError = CalendarModel>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalendarControllerFetchUserCalendarQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>> = ({ signal }) => calendarControllerFetchUserCalendar(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CalendarControllerFetchUserCalendarSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>
export type CalendarControllerFetchUserCalendarSuspenseQueryError = CalendarModel


export function useCalendarControllerFetchUserCalendarSuspense<TData = Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError = CalendarModel>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarControllerFetchUserCalendarSuspense<TData = Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError = CalendarModel>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarControllerFetchUserCalendarSuspense<TData = Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError = CalendarModel>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCalendarControllerFetchUserCalendarSuspense<TData = Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError = CalendarModel>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCalendarControllerFetchUserCalendarSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCalendarControllerFetchUserCalendarSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>, TError = CalendarModel>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCalendarControllerFetchUserCalendarQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>> = ({ signal }) => calendarControllerFetchUserCalendar(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CalendarControllerFetchUserCalendarSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>
export type CalendarControllerFetchUserCalendarSuspenseInfiniteQueryError = CalendarModel


export function useCalendarControllerFetchUserCalendarSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>, TError = CalendarModel>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarControllerFetchUserCalendarSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>, TError = CalendarModel>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCalendarControllerFetchUserCalendarSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>, TError = CalendarModel>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCalendarControllerFetchUserCalendarSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>>, TError = CalendarModel>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof calendarControllerFetchUserCalendar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCalendarControllerFetchUserCalendarSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions , queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const calendarControllerCreate = (
    createCalendarDto: CreateCalendarDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/calendar`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCalendarDto, signal
    },
      options);
    }
  


export const getCalendarControllerCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calendarControllerCreate>>, TError,{data: CreateCalendarDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof calendarControllerCreate>>, TError,{data: CreateCalendarDto}, TContext> => {

const mutationKey = ['calendarControllerCreate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calendarControllerCreate>>, {data: CreateCalendarDto}> = (props) => {
          const {data} = props ?? {};

          return  calendarControllerCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CalendarControllerCreateMutationResult = NonNullable<Awaited<ReturnType<typeof calendarControllerCreate>>>
    export type CalendarControllerCreateMutationBody = CreateCalendarDto
    export type CalendarControllerCreateMutationError = unknown

    export const useCalendarControllerCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calendarControllerCreate>>, TError,{data: CreateCalendarDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calendarControllerCreate>>,
        TError,
        {data: CreateCalendarDto},
        TContext
      > => {

      const mutationOptions = getCalendarControllerCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const calendarControllerAddRowInCalendar = (
    addRowInCalendarDto: AddRowInCalendarDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/calendar/row`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addRowInCalendarDto, signal
    },
      options);
    }
  


export const getCalendarControllerAddRowInCalendarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calendarControllerAddRowInCalendar>>, TError,{data: AddRowInCalendarDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof calendarControllerAddRowInCalendar>>, TError,{data: AddRowInCalendarDto}, TContext> => {

const mutationKey = ['calendarControllerAddRowInCalendar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calendarControllerAddRowInCalendar>>, {data: AddRowInCalendarDto}> = (props) => {
          const {data} = props ?? {};

          return  calendarControllerAddRowInCalendar(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CalendarControllerAddRowInCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof calendarControllerAddRowInCalendar>>>
    export type CalendarControllerAddRowInCalendarMutationBody = AddRowInCalendarDto
    export type CalendarControllerAddRowInCalendarMutationError = unknown

    export const useCalendarControllerAddRowInCalendar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calendarControllerAddRowInCalendar>>, TError,{data: AddRowInCalendarDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calendarControllerAddRowInCalendar>>,
        TError,
        {data: AddRowInCalendarDto},
        TContext
      > => {

      const mutationOptions = getCalendarControllerAddRowInCalendarMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const calendarControllerRemoveRowFromCalendar = (
    rowId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/calendar/row/${rowId}`, method: 'DELETE'
    },
      options);
    }
  


export const getCalendarControllerRemoveRowFromCalendarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calendarControllerRemoveRowFromCalendar>>, TError,{rowId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof calendarControllerRemoveRowFromCalendar>>, TError,{rowId: string}, TContext> => {

const mutationKey = ['calendarControllerRemoveRowFromCalendar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof calendarControllerRemoveRowFromCalendar>>, {rowId: string}> = (props) => {
          const {rowId} = props ?? {};

          return  calendarControllerRemoveRowFromCalendar(rowId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CalendarControllerRemoveRowFromCalendarMutationResult = NonNullable<Awaited<ReturnType<typeof calendarControllerRemoveRowFromCalendar>>>
    
    export type CalendarControllerRemoveRowFromCalendarMutationError = unknown

    export const useCalendarControllerRemoveRowFromCalendar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof calendarControllerRemoveRowFromCalendar>>, TError,{rowId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof calendarControllerRemoveRowFromCalendar>>,
        TError,
        {rowId: string},
        TContext
      > => {

      const mutationOptions = getCalendarControllerRemoveRowFromCalendarMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const sharedWorkControllerCreateSharedWork = (
    createSharedWorkDto: CreateSharedWorkDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CreateSharedWorkResponseModel>(
      {url: `/shared-work`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSharedWorkDto, signal
    },
      options);
    }
  


export const getSharedWorkControllerCreateSharedWorkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sharedWorkControllerCreateSharedWork>>, TError,{data: CreateSharedWorkDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof sharedWorkControllerCreateSharedWork>>, TError,{data: CreateSharedWorkDto}, TContext> => {

const mutationKey = ['sharedWorkControllerCreateSharedWork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sharedWorkControllerCreateSharedWork>>, {data: CreateSharedWorkDto}> = (props) => {
          const {data} = props ?? {};

          return  sharedWorkControllerCreateSharedWork(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SharedWorkControllerCreateSharedWorkMutationResult = NonNullable<Awaited<ReturnType<typeof sharedWorkControllerCreateSharedWork>>>
    export type SharedWorkControllerCreateSharedWorkMutationBody = CreateSharedWorkDto
    export type SharedWorkControllerCreateSharedWorkMutationError = unknown

    export const useSharedWorkControllerCreateSharedWork = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sharedWorkControllerCreateSharedWork>>, TError,{data: CreateSharedWorkDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof sharedWorkControllerCreateSharedWork>>,
        TError,
        {data: CreateSharedWorkDto},
        TContext
      > => {

      const mutationOptions = getSharedWorkControllerCreateSharedWorkMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const customListControllerCreateCustomList = (
    createCustomListDto: CreateCustomListDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CreateCustomListResponseModel>(
      {url: `/custom-list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createCustomListDto, signal
    },
      options);
    }
  


export const getCustomListControllerCreateCustomListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerCreateCustomList>>, TError,{data: CreateCustomListDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof customListControllerCreateCustomList>>, TError,{data: CreateCustomListDto}, TContext> => {

const mutationKey = ['customListControllerCreateCustomList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customListControllerCreateCustomList>>, {data: CreateCustomListDto}> = (props) => {
          const {data} = props ?? {};

          return  customListControllerCreateCustomList(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomListControllerCreateCustomListMutationResult = NonNullable<Awaited<ReturnType<typeof customListControllerCreateCustomList>>>
    export type CustomListControllerCreateCustomListMutationBody = CreateCustomListDto
    export type CustomListControllerCreateCustomListMutationError = unknown

    export const useCustomListControllerCreateCustomList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerCreateCustomList>>, TError,{data: CreateCustomListDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customListControllerCreateCustomList>>,
        TError,
        {data: CreateCustomListDto},
        TContext
      > => {

      const mutationOptions = getCustomListControllerCreateCustomListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const customListControllerFetchCustomLists = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomListModel[]>(
      {url: `/custom-list`, method: 'GET', signal
    },
      options);
    }
  

export const getCustomListControllerFetchCustomListsQueryKey = () => {
    return [`/custom-list`] as const;
    }

    
export const getCustomListControllerFetchCustomListsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomListControllerFetchCustomListsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>> = ({ signal }) => customListControllerFetchCustomLists(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomListControllerFetchCustomListsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>
export type CustomListControllerFetchCustomListsInfiniteQueryError = unknown


export function useCustomListControllerFetchCustomListsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customListControllerFetchCustomLists>>,
          TError,
          Awaited<ReturnType<typeof customListControllerFetchCustomLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customListControllerFetchCustomLists>>,
          TError,
          Awaited<ReturnType<typeof customListControllerFetchCustomLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomListControllerFetchCustomListsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomListControllerFetchCustomListsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions , queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomListControllerFetchCustomListsQueryOptions = <TData = Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomListControllerFetchCustomListsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>> = ({ signal }) => customListControllerFetchCustomLists(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomListControllerFetchCustomListsQueryResult = NonNullable<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>
export type CustomListControllerFetchCustomListsQueryError = unknown


export function useCustomListControllerFetchCustomLists<TData = Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customListControllerFetchCustomLists>>,
          TError,
          Awaited<ReturnType<typeof customListControllerFetchCustomLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomLists<TData = Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customListControllerFetchCustomLists>>,
          TError,
          Awaited<ReturnType<typeof customListControllerFetchCustomLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomLists<TData = Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomListControllerFetchCustomLists<TData = Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomListControllerFetchCustomListsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomListControllerFetchCustomListsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError = unknown>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomListControllerFetchCustomListsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>> = ({ signal }) => customListControllerFetchCustomLists(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomListControllerFetchCustomListsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>
export type CustomListControllerFetchCustomListsSuspenseQueryError = unknown


export function useCustomListControllerFetchCustomListsSuspense<TData = Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError = unknown>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListsSuspense<TData = Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListsSuspense<TData = Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomListControllerFetchCustomListsSuspense<TData = Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomListControllerFetchCustomListsSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomListControllerFetchCustomListsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>, TError = unknown>( options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomListControllerFetchCustomListsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>> = ({ signal }) => customListControllerFetchCustomLists(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomListControllerFetchCustomListsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>
export type CustomListControllerFetchCustomListsSuspenseInfiniteQueryError = unknown


export function useCustomListControllerFetchCustomListsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>, TError = unknown>(
  options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomListControllerFetchCustomListsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>>, TError = unknown>(
  options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomListControllerFetchCustomListsSuspenseInfiniteQueryOptions(options)

  const query = useSuspenseInfiniteQuery(queryOptions , queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const customListControllerUpdateCustomList = (
    id: string,
    updateCustomListDto: UpdateCustomListDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/custom-list/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateCustomListDto
    },
      options);
    }
  


export const getCustomListControllerUpdateCustomListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerUpdateCustomList>>, TError,{id: string;data: UpdateCustomListDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof customListControllerUpdateCustomList>>, TError,{id: string;data: UpdateCustomListDto}, TContext> => {

const mutationKey = ['customListControllerUpdateCustomList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customListControllerUpdateCustomList>>, {id: string;data: UpdateCustomListDto}> = (props) => {
          const {id,data} = props ?? {};

          return  customListControllerUpdateCustomList(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomListControllerUpdateCustomListMutationResult = NonNullable<Awaited<ReturnType<typeof customListControllerUpdateCustomList>>>
    export type CustomListControllerUpdateCustomListMutationBody = UpdateCustomListDto
    export type CustomListControllerUpdateCustomListMutationError = unknown

    export const useCustomListControllerUpdateCustomList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerUpdateCustomList>>, TError,{id: string;data: UpdateCustomListDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customListControllerUpdateCustomList>>,
        TError,
        {id: string;data: UpdateCustomListDto},
        TContext
      > => {

      const mutationOptions = getCustomListControllerUpdateCustomListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const customListControllerDeleteCustomList = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/custom-list/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getCustomListControllerDeleteCustomListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerDeleteCustomList>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof customListControllerDeleteCustomList>>, TError,{id: string}, TContext> => {

const mutationKey = ['customListControllerDeleteCustomList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customListControllerDeleteCustomList>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  customListControllerDeleteCustomList(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomListControllerDeleteCustomListMutationResult = NonNullable<Awaited<ReturnType<typeof customListControllerDeleteCustomList>>>
    
    export type CustomListControllerDeleteCustomListMutationError = unknown

    export const useCustomListControllerDeleteCustomList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerDeleteCustomList>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customListControllerDeleteCustomList>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCustomListControllerDeleteCustomListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const customListControllerFetchCustomListWorks = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomListWithWorksModel>(
      {url: `/custom-list/${id}/works`, method: 'GET', signal
    },
      options);
    }
  

export const getCustomListControllerFetchCustomListWorksQueryKey = (id: string,) => {
    return [`/custom-list/${id}/works`] as const;
    }

    
export const getCustomListControllerFetchCustomListWorksInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>, TError = unknown>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomListControllerFetchCustomListWorksQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>> = ({ signal }) => customListControllerFetchCustomListWorks(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomListControllerFetchCustomListWorksInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>
export type CustomListControllerFetchCustomListWorksInfiniteQueryError = unknown


export function useCustomListControllerFetchCustomListWorksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>, TError = unknown>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>,
          TError,
          Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListWorksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>,
          TError,
          Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListWorksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomListControllerFetchCustomListWorksInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomListControllerFetchCustomListWorksInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions , queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomListControllerFetchCustomListWorksQueryOptions = <TData = Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomListControllerFetchCustomListWorksQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>> = ({ signal }) => customListControllerFetchCustomListWorks(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomListControllerFetchCustomListWorksQueryResult = NonNullable<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>
export type CustomListControllerFetchCustomListWorksQueryError = unknown


export function useCustomListControllerFetchCustomListWorks<TData = Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>,
          TError,
          Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListWorks<TData = Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>,
          TError,
          Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListWorks<TData = Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomListControllerFetchCustomListWorks<TData = Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomListControllerFetchCustomListWorksQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomListControllerFetchCustomListWorksSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError = unknown>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomListControllerFetchCustomListWorksQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>> = ({ signal }) => customListControllerFetchCustomListWorks(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomListControllerFetchCustomListWorksSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>
export type CustomListControllerFetchCustomListWorksSuspenseQueryError = unknown


export function useCustomListControllerFetchCustomListWorksSuspense<TData = Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError = unknown>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListWorksSuspense<TData = Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListWorksSuspense<TData = Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomListControllerFetchCustomListWorksSuspense<TData = Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomListControllerFetchCustomListWorksSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCustomListControllerFetchCustomListWorksSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>, TError = unknown>(id: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCustomListControllerFetchCustomListWorksQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>> = ({ signal }) => customListControllerFetchCustomListWorks(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CustomListControllerFetchCustomListWorksSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>
export type CustomListControllerFetchCustomListWorksSuspenseInfiniteQueryError = unknown


export function useCustomListControllerFetchCustomListWorksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>, TError = unknown>(
 id: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListWorksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCustomListControllerFetchCustomListWorksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useCustomListControllerFetchCustomListWorksSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof customListControllerFetchCustomListWorks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCustomListControllerFetchCustomListWorksSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions , queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const customListControllerAddWorkToCustomList = (
    id: string,
    addWorkInCustomListDto: AddWorkInCustomListDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/custom-list/${id}/works`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addWorkInCustomListDto, signal
    },
      options);
    }
  


export const getCustomListControllerAddWorkToCustomListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerAddWorkToCustomList>>, TError,{id: string;data: AddWorkInCustomListDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof customListControllerAddWorkToCustomList>>, TError,{id: string;data: AddWorkInCustomListDto}, TContext> => {

const mutationKey = ['customListControllerAddWorkToCustomList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customListControllerAddWorkToCustomList>>, {id: string;data: AddWorkInCustomListDto}> = (props) => {
          const {id,data} = props ?? {};

          return  customListControllerAddWorkToCustomList(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomListControllerAddWorkToCustomListMutationResult = NonNullable<Awaited<ReturnType<typeof customListControllerAddWorkToCustomList>>>
    export type CustomListControllerAddWorkToCustomListMutationBody = AddWorkInCustomListDto
    export type CustomListControllerAddWorkToCustomListMutationError = unknown

    export const useCustomListControllerAddWorkToCustomList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerAddWorkToCustomList>>, TError,{id: string;data: AddWorkInCustomListDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customListControllerAddWorkToCustomList>>,
        TError,
        {id: string;data: AddWorkInCustomListDto},
        TContext
      > => {

      const mutationOptions = getCustomListControllerAddWorkToCustomListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const customListControllerDeleteWorkFromCustomList = (
    id: string,
    workId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/custom-list/${id}/works/${workId}`, method: 'DELETE'
    },
      options);
    }
  


export const getCustomListControllerDeleteWorkFromCustomListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerDeleteWorkFromCustomList>>, TError,{id: string;workId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof customListControllerDeleteWorkFromCustomList>>, TError,{id: string;workId: string}, TContext> => {

const mutationKey = ['customListControllerDeleteWorkFromCustomList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customListControllerDeleteWorkFromCustomList>>, {id: string;workId: string}> = (props) => {
          const {id,workId} = props ?? {};

          return  customListControllerDeleteWorkFromCustomList(id,workId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomListControllerDeleteWorkFromCustomListMutationResult = NonNullable<Awaited<ReturnType<typeof customListControllerDeleteWorkFromCustomList>>>
    
    export type CustomListControllerDeleteWorkFromCustomListMutationError = unknown

    export const useCustomListControllerDeleteWorkFromCustomList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerDeleteWorkFromCustomList>>, TError,{id: string;workId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customListControllerDeleteWorkFromCustomList>>,
        TError,
        {id: string;workId: string},
        TContext
      > => {

      const mutationOptions = getCustomListControllerDeleteWorkFromCustomListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const customListControllerShareCustomList = (
    toggleShareCollectionDto: ToggleShareCollectionDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/custom-list/share`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: toggleShareCollectionDto
    },
      options);
    }
  


export const getCustomListControllerShareCustomListMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerShareCustomList>>, TError,{data: ToggleShareCollectionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof customListControllerShareCustomList>>, TError,{data: ToggleShareCollectionDto}, TContext> => {

const mutationKey = ['customListControllerShareCustomList'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof customListControllerShareCustomList>>, {data: ToggleShareCollectionDto}> = (props) => {
          const {data} = props ?? {};

          return  customListControllerShareCustomList(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CustomListControllerShareCustomListMutationResult = NonNullable<Awaited<ReturnType<typeof customListControllerShareCustomList>>>
    export type CustomListControllerShareCustomListMutationBody = ToggleShareCollectionDto
    export type CustomListControllerShareCustomListMutationError = unknown

    export const useCustomListControllerShareCustomList = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof customListControllerShareCustomList>>, TError,{data: ToggleShareCollectionDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof customListControllerShareCustomList>>,
        TError,
        {data: ToggleShareCollectionDto},
        TContext
      > => {

      const mutationOptions = getCustomListControllerShareCustomListMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const scrappingReportControllerScrappingFallback = (
    scrappingReportDto: ScrappingReportDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/scrapping-report`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: scrappingReportDto, signal
    },
      options);
    }
  


export const getScrappingReportControllerScrappingFallbackMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerScrappingFallback>>, TError,{data: ScrappingReportDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerScrappingFallback>>, TError,{data: ScrappingReportDto}, TContext> => {

const mutationKey = ['scrappingReportControllerScrappingFallback'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scrappingReportControllerScrappingFallback>>, {data: ScrappingReportDto}> = (props) => {
          const {data} = props ?? {};

          return  scrappingReportControllerScrappingFallback(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ScrappingReportControllerScrappingFallbackMutationResult = NonNullable<Awaited<ReturnType<typeof scrappingReportControllerScrappingFallback>>>
    export type ScrappingReportControllerScrappingFallbackMutationBody = ScrappingReportDto
    export type ScrappingReportControllerScrappingFallbackMutationError = unknown

    export const useScrappingReportControllerScrappingFallback = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerScrappingFallback>>, TError,{data: ScrappingReportDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scrappingReportControllerScrappingFallback>>,
        TError,
        {data: ScrappingReportDto},
        TContext
      > => {

      const mutationOptions = getScrappingReportControllerScrappingFallbackMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const scrappingReportControllerFetchForWorksScrapingReportPaginated = (
    params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ScrappingReportModel>(
      {url: `/scrapping-report`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getScrappingReportControllerFetchForWorksScrapingReportPaginatedQueryKey = (params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams,) => {
    return [`/scrapping-report`, ...(params ? [params]: [])] as const;
    }

    
export const getScrappingReportControllerFetchForWorksScrapingReportPaginatedInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>, TError = unknown>(params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getScrappingReportControllerFetchForWorksScrapingReportPaginatedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']> = ({ signal, pageParam }) => scrappingReportControllerFetchForWorksScrapingReportPaginated({...params, 'page': pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ScrappingReportControllerFetchForWorksScrapingReportPaginatedInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>>
export type ScrappingReportControllerFetchForWorksScrapingReportPaginatedInfiniteQueryError = unknown


export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedInfinite<TData = InfiniteData<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>,
          TError,
          Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedInfinite<TData = InfiniteData<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>,
          TError,
          Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedInfinite<TData = InfiniteData<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedInfinite<TData = InfiniteData<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScrappingReportControllerFetchForWorksScrapingReportPaginatedInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions , queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getScrappingReportControllerFetchForWorksScrapingReportPaginatedQueryOptions = <TData = Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError = unknown>(params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getScrappingReportControllerFetchForWorksScrapingReportPaginatedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>> = ({ signal }) => scrappingReportControllerFetchForWorksScrapingReportPaginated(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ScrappingReportControllerFetchForWorksScrapingReportPaginatedQueryResult = NonNullable<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>>
export type ScrappingReportControllerFetchForWorksScrapingReportPaginatedQueryError = unknown


export function useScrappingReportControllerFetchForWorksScrapingReportPaginated<TData = Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>,
          TError,
          Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScrappingReportControllerFetchForWorksScrapingReportPaginated<TData = Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>,
          TError,
          Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScrappingReportControllerFetchForWorksScrapingReportPaginated<TData = Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useScrappingReportControllerFetchForWorksScrapingReportPaginated<TData = Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScrappingReportControllerFetchForWorksScrapingReportPaginatedQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError = unknown>(params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getScrappingReportControllerFetchForWorksScrapingReportPaginatedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>> = ({ signal }) => scrappingReportControllerFetchForWorksScrapingReportPaginated(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>>
export type ScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseQueryError = unknown


export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspense<TData = Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspense<TData = Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspense<TData = Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspense<TData = Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>, TError = unknown>(params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getScrappingReportControllerFetchForWorksScrapingReportPaginatedQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']> = ({ signal, pageParam }) => scrappingReportControllerFetchForWorksScrapingReportPaginated({...params, 'page': pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>>
export type ScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseInfiniteQueryError = unknown


export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>, TError = unknown>(
 params: ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, TError, TData, Awaited<ReturnType<typeof scrappingReportControllerFetchForWorksScrapingReportPaginated>>, QueryKey, ScrappingReportControllerFetchForWorksScrapingReportPaginatedParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getScrappingReportControllerFetchForWorksScrapingReportPaginatedSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions , queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const scrappingReportControllerSyncWork = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/scrapping-report/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getScrappingReportControllerSyncWorkMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerSyncWork>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerSyncWork>>, TError,void, TContext> => {

const mutationKey = ['scrappingReportControllerSyncWork'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scrappingReportControllerSyncWork>>, void> = () => {
          

          return  scrappingReportControllerSyncWork(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ScrappingReportControllerSyncWorkMutationResult = NonNullable<Awaited<ReturnType<typeof scrappingReportControllerSyncWork>>>
    
    export type ScrappingReportControllerSyncWorkMutationError = unknown

    export const useScrappingReportControllerSyncWork = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerSyncWork>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scrappingReportControllerSyncWork>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getScrappingReportControllerSyncWorkMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const scrappingReportControllerRefreshChapters = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/scrapping-report/sync/all`, method: 'POST', signal
    },
      options);
    }
  


export const getScrappingReportControllerRefreshChaptersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerRefreshChapters>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerRefreshChapters>>, TError,void, TContext> => {

const mutationKey = ['scrappingReportControllerRefreshChapters'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scrappingReportControllerRefreshChapters>>, void> = () => {
          

          return  scrappingReportControllerRefreshChapters(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ScrappingReportControllerRefreshChaptersMutationResult = NonNullable<Awaited<ReturnType<typeof scrappingReportControllerRefreshChapters>>>
    
    export type ScrappingReportControllerRefreshChaptersMutationError = unknown

    export const useScrappingReportControllerRefreshChapters = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerRefreshChapters>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scrappingReportControllerRefreshChapters>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getScrappingReportControllerRefreshChaptersMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const scrappingReportControllerSyncToNotion = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/scrapping-report/sync/notion`, method: 'POST', signal
    },
      options);
    }
  


export const getScrappingReportControllerSyncToNotionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerSyncToNotion>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerSyncToNotion>>, TError,void, TContext> => {

const mutationKey = ['scrappingReportControllerSyncToNotion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof scrappingReportControllerSyncToNotion>>, void> = () => {
          

          return  scrappingReportControllerSyncToNotion(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ScrappingReportControllerSyncToNotionMutationResult = NonNullable<Awaited<ReturnType<typeof scrappingReportControllerSyncToNotion>>>
    
    export type ScrappingReportControllerSyncToNotionMutationError = unknown

    export const useScrappingReportControllerSyncToNotion = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof scrappingReportControllerSyncToNotion>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof scrappingReportControllerSyncToNotion>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getScrappingReportControllerSyncToNotionMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const adminControllerFetchUsers = (
    params: AdminControllerFetchUsersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FetchUsersModel>(
      {url: `/admin/users`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getAdminControllerFetchUsersQueryKey = (params: AdminControllerFetchUsersParams,) => {
    return [`/admin/users`, ...(params ? [params]: [])] as const;
    }

    
export const getAdminControllerFetchUsersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminControllerFetchUsers>>, AdminControllerFetchUsersParams['page']>, TError = unknown>(params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminControllerFetchUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']> = ({ signal, pageParam }) => adminControllerFetchUsers({...params, 'page': pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminControllerFetchUsersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminControllerFetchUsers>>>
export type AdminControllerFetchUsersInfiniteQueryError = unknown


export function useAdminControllerFetchUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminControllerFetchUsers>>, AdminControllerFetchUsersParams['page']>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerFetchUsers>>,
          TError,
          Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminControllerFetchUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminControllerFetchUsers>>, AdminControllerFetchUsersParams['page']>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerFetchUsers>>,
          TError,
          Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminControllerFetchUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminControllerFetchUsers>>, AdminControllerFetchUsersParams['page']>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminControllerFetchUsersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminControllerFetchUsers>>, AdminControllerFetchUsersParams['page']>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminControllerFetchUsersInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions , queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdminControllerFetchUsersQueryOptions = <TData = Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError = unknown>(params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminControllerFetchUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerFetchUsers>>> = ({ signal }) => adminControllerFetchUsers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminControllerFetchUsersQueryResult = NonNullable<Awaited<ReturnType<typeof adminControllerFetchUsers>>>
export type AdminControllerFetchUsersQueryError = unknown


export function useAdminControllerFetchUsers<TData = Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerFetchUsers>>,
          TError,
          Awaited<ReturnType<typeof adminControllerFetchUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminControllerFetchUsers<TData = Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminControllerFetchUsers>>,
          TError,
          Awaited<ReturnType<typeof adminControllerFetchUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminControllerFetchUsers<TData = Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminControllerFetchUsers<TData = Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminControllerFetchUsersQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdminControllerFetchUsersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError = unknown>(params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminControllerFetchUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerFetchUsers>>> = ({ signal }) => adminControllerFetchUsers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminControllerFetchUsersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof adminControllerFetchUsers>>>
export type AdminControllerFetchUsersSuspenseQueryError = unknown


export function useAdminControllerFetchUsersSuspense<TData = Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminControllerFetchUsersSuspense<TData = Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminControllerFetchUsersSuspense<TData = Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminControllerFetchUsersSuspense<TData = Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminControllerFetchUsersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions , queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAdminControllerFetchUsersSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof adminControllerFetchUsers>>, AdminControllerFetchUsersParams['page']>, TError = unknown>(params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAdminControllerFetchUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']> = ({ signal, pageParam }) => adminControllerFetchUsers({...params, 'page': pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AdminControllerFetchUsersSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof adminControllerFetchUsers>>>
export type AdminControllerFetchUsersSuspenseInfiniteQueryError = unknown


export function useAdminControllerFetchUsersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminControllerFetchUsers>>, AdminControllerFetchUsersParams['page']>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminControllerFetchUsersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminControllerFetchUsers>>, AdminControllerFetchUsersParams['page']>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAdminControllerFetchUsersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminControllerFetchUsers>>, AdminControllerFetchUsersParams['page']>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useAdminControllerFetchUsersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof adminControllerFetchUsers>>, AdminControllerFetchUsersParams['page']>, TError = unknown>(
 params: AdminControllerFetchUsersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof adminControllerFetchUsers>>, TError, TData, Awaited<ReturnType<typeof adminControllerFetchUsers>>, QueryKey, AdminControllerFetchUsersParams['page']>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAdminControllerFetchUsersSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions , queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const adminControllerUpdateUserRole = (
    userId: string,
    updateUserRoleDto: UpdateUserRoleDto,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/users/${userId}/role`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRoleDto
    },
      options);
    }
  


export const getAdminControllerUpdateUserRoleMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminControllerUpdateUserRole>>, TError,{userId: string;data: UpdateUserRoleDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminControllerUpdateUserRole>>, TError,{userId: string;data: UpdateUserRoleDto}, TContext> => {

const mutationKey = ['adminControllerUpdateUserRole'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminControllerUpdateUserRole>>, {userId: string;data: UpdateUserRoleDto}> = (props) => {
          const {userId,data} = props ?? {};

          return  adminControllerUpdateUserRole(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminControllerUpdateUserRoleMutationResult = NonNullable<Awaited<ReturnType<typeof adminControllerUpdateUserRole>>>
    export type AdminControllerUpdateUserRoleMutationBody = UpdateUserRoleDto
    export type AdminControllerUpdateUserRoleMutationError = unknown

    export const useAdminControllerUpdateUserRole = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminControllerUpdateUserRole>>, TError,{userId: string;data: UpdateUserRoleDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminControllerUpdateUserRole>>,
        TError,
        {userId: string;data: UpdateUserRoleDto},
        TContext
      > => {

      const mutationOptions = getAdminControllerUpdateUserRoleMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const adminControllerDeleteUser = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/admin/users/${userId}`, method: 'DELETE'
    },
      options);
    }
  


export const getAdminControllerDeleteUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminControllerDeleteUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminControllerDeleteUser>>, TError,{userId: string}, TContext> => {

const mutationKey = ['adminControllerDeleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminControllerDeleteUser>>, {userId: string}> = (props) => {
          const {userId} = props ?? {};

          return  adminControllerDeleteUser(userId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminControllerDeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof adminControllerDeleteUser>>>
    
    export type AdminControllerDeleteUserMutationError = unknown

    export const useAdminControllerDeleteUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminControllerDeleteUser>>, TError,{userId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminControllerDeleteUser>>,
        TError,
        {userId: string},
        TContext
      > => {

      const mutationOptions = getAdminControllerDeleteUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const adminControllerResetScrappingForAllWorks = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/admin/batch/reset-scrapping`, method: 'POST', signal
    },
      options);
    }
  


export const getAdminControllerResetScrappingForAllWorksMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminControllerResetScrappingForAllWorks>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminControllerResetScrappingForAllWorks>>, TError,void, TContext> => {

const mutationKey = ['adminControllerResetScrappingForAllWorks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminControllerResetScrappingForAllWorks>>, void> = () => {
          

          return  adminControllerResetScrappingForAllWorks(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminControllerResetScrappingForAllWorksMutationResult = NonNullable<Awaited<ReturnType<typeof adminControllerResetScrappingForAllWorks>>>
    
    export type AdminControllerResetScrappingForAllWorksMutationError = unknown

    export const useAdminControllerResetScrappingForAllWorks = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminControllerResetScrappingForAllWorks>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminControllerResetScrappingForAllWorks>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAdminControllerResetScrappingForAllWorksMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const adminControllerCreateSubscriberPost = (
    createSubscriberDto: CreateSubscriberDto,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/admin/subscriber`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSubscriberDto, signal
    },
      options);
    }
  


export const getAdminControllerCreateSubscriberPostMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminControllerCreateSubscriberPost>>, TError,{data: CreateSubscriberDto}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof adminControllerCreateSubscriberPost>>, TError,{data: CreateSubscriberDto}, TContext> => {

const mutationKey = ['adminControllerCreateSubscriberPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof adminControllerCreateSubscriberPost>>, {data: CreateSubscriberDto}> = (props) => {
          const {data} = props ?? {};

          return  adminControllerCreateSubscriberPost(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AdminControllerCreateSubscriberPostMutationResult = NonNullable<Awaited<ReturnType<typeof adminControllerCreateSubscriberPost>>>
    export type AdminControllerCreateSubscriberPostMutationBody = CreateSubscriberDto
    export type AdminControllerCreateSubscriberPostMutationError = unknown

    export const useAdminControllerCreateSubscriberPost = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof adminControllerCreateSubscriberPost>>, TError,{data: CreateSubscriberDto}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof adminControllerCreateSubscriberPost>>,
        TError,
        {data: CreateSubscriberDto},
        TContext
      > => {

      const mutationOptions = getAdminControllerCreateSubscriberPostMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
